import './WeatherCard.scss';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchResultWeather } from 'src/state/SearchResult';
import { getClasses } from 'src/utils/classFunctions';
import { classList } from 'src/utils/classList';
import { IconWeather } from 'src/components/Icon/IconWeather';
import { IconSunshine } from 'src/components/Icon/IconSunshine';
import { IconUmbrella } from 'src/components/Icon/IconUmbrella';
import { IconDawndusk } from 'src/components/Icon/IconDawndusk';

type Props = {
    readonly modificators?: ReadonlyArray<string>;
    readonly variant?: string;
    readonly searchItem: SearchResultWeather;
};

export function WeatherCard(props: Props): JSX.Element {
    const { modificators = [], variant, searchItem: { weatherLocation, weatherData } } = props;

    return (
        <div className={classList(getClasses('lvo-weather-card', modificators), variant)}>
            <div className="lvo-weather-card__header">
                <div className="lvo-weather-card__title">
                    {weatherLocation
                        ? <span className="lvo-weather-card__location">{weatherLocation}</span>
                        : null}
                    <span className="lvo-weather-card__current-date">
                        {weatherData.currentDate}
                    </span>
                </div>
                <div className="lvo-weather-card__subtitle">
                    {weatherData.weatherProviderTitle}
                </div>
                <div className="lvo-weather-card__updated">
                    {weatherData.producedDate}
                </div>
            </div>
            <div className="weather-today__actual">
                <div className="lvo-weather-card-actual">
                    <div className="lvo-weather-card-actual__box">
                        <div className="lvo-weather-card-actual__columns">
                            <div className="lvo-weather-card-actual__morning">
                                <div className="lvo-weather-card-actual__column-title">
                                    {weatherData.morningTitle}
                                </div>
                                <div className="lvo-weather-card-actual__icon">
                                    <IconWeather icon={weatherData.todayMorningIcon}/>
                                </div>
                            </div>
                            <div className="lvo-weather-card-actual__afternoon">
                                <div className="lvo-weather-card-actual__column-title">
                                    {weatherData.afternoonTitle}
                                </div>
                                <div className="lvo-weather-card-actual__icon">
                                    <IconWeather icon={weatherData.todayAfternoonIcon}/>
                                </div>
                            </div>
                            <div className="lvo-weather-card-actual__evening">
                                <div className="lvo-weather-card-actual__column-title">
                                    {weatherData.eveningTitle}
                                </div>
                                <div className="lvo-weather-card-actual__icon">
                                    <IconWeather icon={weatherData.todayEveningIcon}/>
                                </div>
                            </div>
                        </div>
                        <div className="lvo-weather-card-actual__prognose">
                            <div className="lvo-weather-card-actual__column-title lvo-weather-card-actual__column-title--prognose">
                                {weatherData.currentForecastTitle}
                            </div>
                            <div className="lvo-weather-card-actual__minimax">
                                <span className="lvo-weather-card-actual__minimax-label">Min </span>
                                <span className="lvo-weather-card-actual__minimax-num">
                                    {weatherData.todayMinTemp}
                                </span> &deg;C /
                                <span className="lvo-weather-card-actual__minimax-label"> Max </span>
                                <span className="lvo-weather-card-actual__minimax-num">
                                    {weatherData.todayMaxTemp}
                                </span> &deg;C
                            </div>
                            <div className="lvo-weather-card-actual__data">
                                {weatherData.sunshineTitle}
                                <IconSunshine/>
                                <span>{weatherData.sunshineTime} h</span>
                            </div>
                            <div className="lvo-weather-card-actual__data">
                                {weatherData.precipitationProbabilityTitle}
                                <span style={{ whiteSpace: 'nowrap' }}>
                                    <IconUmbrella/>
                                    <span>{weatherData.precipitationProbabilityToday} %</span>
                                </span>
                            </div>
                            <div className="lvo-weather-card-actual__data lvo-weather-card-actual__data--no-border">
                                {weatherData.sunriseAndSunsetTitle}
                                <div className="lvo-weather-card-actual__sunrise-sunset">
                                    <IconDawndusk/>
                                    <span>
                                        {weatherData.sunriseTime} h / {weatherData.sunsetTime} h
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="lvo-weather-card-actual__text">
                            {weatherData.todayText}
                            <br />
                            <br />
                            <a target="_blank" href={weatherData.tabUrls.tomorrowLink}>
                                <FormattedMessage id="searchWeather_tomorrowLink"/>
                            </a>
                            <a target="_blank" href={weatherData.tabUrls.nextDaysLink}>
                                <FormattedMessage id="searchWeather_nextDaysLink"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
